/*
 * @Author: yuhaiyangz@163.com
 * @Date: 2023-01-31 15:58:51
 * @LastEditors: yuhaiyang yuhaiyangz@163.com
 * @LastEditTime: 2026-04-17 09:37:37
 * @Description: 请填写简介
 */
import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useNavigate,useLocation } from 'react-router-dom'
import { Popup, Collapse, Space, List, Switch } from 'antd-mobile'
import './header.scss'
import menu from './img/menu.png'
import { useTranslation } from 'react-i18next';
interface path {
    readonly title: string,
    readonly url: string,
    list?: path[];
    index?: string;//选中状态
}

export default function CCHeader() {
    const [visible, setVisible] = useState<boolean>(false)
    const location = useLocation();
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const [checked, setChecked] = useState<boolean>(true)
    const headerList: path[] = [//导航
        { title: t('homePath'), url: '/' },
        { title: t('llqPath'), url: '/indexType' },
        {
            title: t('khPath'), url: '/customers/', list: [
                { title: t('khPath1'), url: '/customers/1' },
                { title: t('khPath2'), url: '/customers/2' },
                { title: t('khPath3'), url: '/customers/3' },
                { title: t('khPath4'), url: '/customers/4' },
            ]
        },
        {
            title: t('jjfaPath'), url: '/solution/', list: [
                { title: t('jjfaPath1'), url: '/solution/crossAsset' },
                { title: t('jjfaPath2'), url: '/solution/bond' },
                { title: t('jjfaPath3'), url: '/solution/fof' }
            ]
        },
        { title: t('newsPath'), url: '/news' },
        { title: t('yjPath'), url: '/research' },
        { title: t('gywmPath4'), url: '/compliance' },
        { title: t('gywmPath1'), url: '/company' },
        { title: t('gywmPath2'), url: '/join' },
        { title: t('gywmPath3'), url: '/contactUs' }
        // {
        //    title: '关于我们', url: '', list: [
        //       { title: '公司介绍', url: '/company', index: '/company' + 0 },
        //       { title: '加入我们', url: '/join', index: '/join' + 1 },
        //       { title: '联系我们', url: '/contactUs', index: '/contactUs' + 2 },
        //       { title: '合规管理', url: '/compliance', index: '/compliance' + 3 },
        //    ]
        // },

    ]
    const goHome = () => {
        navigate('/')
    }
    useEffect(() => {
        const type = i18n.language
        console.log(type);
        if (type == 'zh') {
            setChecked(true)
        }else{
            setChecked(false) 
        }
    }, [])
    return (
        <div className='ccxd_header'>
            <img className='logo' src="/img/logo.png" alt="" onClick={() => goHome()} />
            <img className='menu' src={menu} alt="icon" onClick={() => setVisible(true)} />
            <Popup
                visible={visible}
                onMaskClick={() => {
                    setVisible(false)
                }}
                position='left'
                bodyStyle={{ width: '60vw' }}
                className="ccxd_header"
            >
                <div className='headerLang'>
                    <p>{t('lang')}</p>
                    <Switch style={{ zoom: 0.6 }} checked={checked} uncheckedText='EN' checkedText='ZH' onChange={val => {
                        setChecked(val)
                        let lang = 'zh'
                        if (val) {
                            lang = 'zh'
                        } else {
                            lang = 'en'
                        }
                        i18n.changeLanguage('en');
                        const pathWithoutLang = location.pathname.replace(/^\/[^/]+/, '') || '/';
                        // 2. 拼接新路径：新语言 + 原路径
                        const newPath = `/${lang}${pathWithoutLang}${location.search}`;
                        navigate(newPath, { replace: true });
                        document.location.reload()
                    }} />
                </div>
                <List header={t('nav')}>
                    {
                        headerList.map(item => {
                            if (!item.list) {
                                return <List.Item key={item.url}><NavLink to={'/'+i18n.language+ item.url} onClick={() => setVisible(false)}>{item.title}</NavLink></List.Item>
                            } else {
                                return (
                                    <Collapse key={item.url} accordion>
                                        <Collapse.Panel key='1' title={item.title}>
                                            <Space direction='vertical'>
                                                {
                                                    item.list.map(child => {
                                                        return <NavLink style={{ lineHeight: 2.5 }} key={child.url} to={'/'+i18n.language+child.url} onClick={() => setVisible(false)}>{child.title}</NavLink>
                                                    })
                                                }
                                            </Space>
                                        </Collapse.Panel>
                                    </Collapse>
                                )
                            }
                        })
                    }
                </List>
            </Popup>
        </div>

    )
}